import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React, { Component, Fragment } from "react";
import { createPortal } from "react-dom";
import { compose } from "recompose";
var TRANSLATE_HORIZONTAL = "translateX(-50%)";
var TRANSLATE_VERTICAL = "translateY(-50%)";
var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);
  var _super = _createSuper(Tooltip);
  function Tooltip() {
    var _this;
    _classCallCheck(this, Tooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      active: false
    };
    _this.getParentProps = function () {
      var _objectSpread2;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref$refKey = _ref.refKey,
        refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        props = _objectWithoutProperties(_ref, ["refKey", "onMouseEnter", "onMouseLeave"]);
      return _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, refKey, function (e) {
        return _this.parent = e;
      }), _defineProperty(_objectSpread2, "onMouseEnter", composeEventHandlers(onMouseEnter, _this.onMouseEnter)), _defineProperty(_objectSpread2, "onMouseLeave", composeEventHandlers(onMouseLeave, _this.onMouseLeave)), _objectSpread2), props);
    };
    _this.getOverlayProps = function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onMouseEnter = _ref2.onMouseEnter,
        onMouseLeave = _ref2.onMouseLeave,
        props = _objectWithoutProperties(_ref2, ["onMouseEnter", "onMouseLeave"]);
      return _objectSpread({
        onMouseEnter: composeEventHandlers(onMouseEnter, _this.onMouseEnter),
        onMouseLeave: composeEventHandlers(onMouseLeave, _this.onMouseLeave)
      }, props);
    };
    _this.onMouseEnter = function (props) {
      if (_this.mouseLeaveTimeout) clearTimeout(_this.mouseLeaveTimeout);
      _this.updateParentRect();
      _this.props.onMouseEnter(props);
      if (_this.props.active === undefined) _this.setState({
        active: true
      });
    };
    _this.onMouseLeave = function (event) {
      _this.mouseLeaveTimeout = setTimeout(function () {
        return _this.onMouseLeaveImmediate(event);
      }, _this.props.leaveTimeout);
    };
    _this.onMouseLeaveImmediate = function (event) {
      _this.props.onMouseLeave(event);
      if (_this.props.active === undefined) {
        _this.setState({
          active: false
        });
      }
    };
    return _this;
  }
  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateParentRect();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        position = _this$props.position,
        offset = _this$props.offset,
        parent = _this$props.parent,
        children = _this$props.children,
        _this$props$renderPar = _this$props.renderParent,
        renderParent = _this$props$renderPar === void 0 ? parent : _this$props$renderPar,
        _this$props$renderOve = _this$props.renderOverlay,
        renderOverlay = _this$props$renderOve === void 0 ? children : _this$props$renderOve;
      var parentRect = this.state.parentRect;
      return /*#__PURE__*/React.createElement(Fragment, null, renderParent(this.getParentStateAndHelpers()), /*#__PURE__*/React.createElement(Overlay, {
        position: position,
        offset: offset,
        parentRect: parentRect
      }, function (overlay) {
        return renderOverlay(_this2.getOverlayStateAndHelpers(overlay));
      }));
    }
  }, {
    key: "getParentStateAndHelpers",
    value: function getParentStateAndHelpers() {
      var active = this.active,
        getProps = this.getParentProps;
      return {
        active: active,
        getProps: getProps
      };
    }
  }, {
    key: "getOverlayStateAndHelpers",
    value: function getOverlayStateAndHelpers(_ref3) {
      var getProps = _ref3.getProps,
        overlay = _objectWithoutProperties(_ref3, ["getProps"]);
      var active = this.active,
        getOverlayProps = this.getOverlayProps;
      return _objectSpread({
        active: active,
        getProps: compose(getProps, getOverlayProps)
      }, overlay);
    }
  }, {
    key: "active",
    get: function get() {
      return this.props.active === undefined ? this.state.active : this.props.active;
    }
  }, {
    key: "updateParentRect",
    value: function updateParentRect() {
      var _document$documentEle = document.documentElement.getBoundingClientRect(),
        documentX = _document$documentEle.left,
        documentY = _document$documentEle.top;
      var _this$parent$getBound = this.parent.getBoundingClientRect(),
        parentX = _this$parent$getBound.left,
        parentY = _this$parent$getBound.top,
        width = _this$parent$getBound.width,
        height = _this$parent$getBound.height;
      var x = parentX - documentX;
      var y = parentY - documentY;
      this.setState({
        parentRect: {
          x: x,
          y: y,
          width: width,
          height: height
        }
      });
    }
  }]);
  return Tooltip;
}(Component);
Tooltip.defaultProps = {
  leaveTimeout: 300,
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {}
};
var Overlay = function Overlay(_ref4) {
  var _ref4$position = _ref4.position,
    position = _ref4$position === void 0 ? "bottom" : _ref4$position,
    _ref4$offset = _ref4.offset,
    offset = _ref4$offset === void 0 ? 0 : _ref4$offset,
    parentRect = _ref4.parentRect,
    children = _ref4.children,
    _ref4$render = _ref4.render,
    render = _ref4$render === void 0 ? children : _ref4$render;
  if (!parentRect) return null;
  var getProps = function getProps() {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var style = _ref5.style,
      props = _objectWithoutProperties(_ref5, ["style"]);
    return _objectSpread({
      style: _objectSpread({}, style, getOverlayStyle(position, parentRect, offset))
    }, props);
  };
  return createPortal(render({
    position: position,
    getProps: getProps
  }), window.document.body);
};
var getOverlayStyle = function getOverlayStyle(position, parentRect, offset) {
  var x = parentRect.x,
    y = parentRect.y,
    width = parentRect.width,
    height = parentRect.height;
  var left;
  var top;
  var transform;
  switch (position) {
    case "top":
      left = x + width / 2;
      top = y - offset;
      transform = TRANSLATE_HORIZONTAL;
      break;
    case "left":
      left = x - offset;
      top = y + height / 2;
      transform = TRANSLATE_VERTICAL;
      break;
    case "bottom":
      left = x + width / 2;
      top = y + height + offset;
      transform = TRANSLATE_HORIZONTAL;
      break;
    case "right":
      left = x + width + offset;
      top = y + height / 2;
      transform = TRANSLATE_VERTICAL;
      break;
    default:
      break;
  }
  return {
    position: "absolute",
    left: left,
    top: top,
    transform: transform
  };
};
var composeEventHandlers = function composeEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function (event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return fns.some(function (fn) {
      fn && fn.apply(void 0, [event].concat(args));
      return event.defaultPrevented;
    });
  };
};
export default Tooltip;